import React from "react";
import "./AttackSurfaceScore.css";

interface NodeTypeCounts {
  vulnerabilities: number;
  agents: number;
  tools: number;
  mcpServers: number;
}

interface AttackSurfaceScoreProps {
  nodeTypes: NodeTypeCounts;
}

// SVG Icons matching the design
const VulnerabilityIcon = ({ color }: { color: string }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
  </svg>
);

const AgentIcon = ({ color }: { color: string }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z"/>
  </svg>
);

const ToolIcon = ({ color }: { color: string }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
  </svg>
);

const McpServerIcon = ({ color }: { color: string }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/>
  </svg>
);

const NODE_TYPE_ITEMS = [
//   { key: "vulnerabilities" as const, label: "Vulnerabilities", color: "#ff4d4f", Icon: VulnerabilityIcon },
  { key: "agents" as const, label: "Agents", color: "#a78bfa", Icon: AgentIcon },
  { key: "tools" as const, label: "Tools", color: "#22d3ee", Icon: ToolIcon },
  { key: "mcpServers" as const, label: "MCP Servers", color: "#4ade80", Icon: McpServerIcon },
];

const AttackSurfaceScore: React.FC<AttackSurfaceScoreProps> = ({ nodeTypes }) => {
  return (
    <div className="ass-card">
      <div className="ass-findings-section">
        <div className="ass-findings-body">
          {NODE_TYPE_ITEMS.map(({ key, label, color, Icon }) => (
            <div className="ass-finding-item" key={key}>
              <Icon color={color} />
              <span className="ass-finding-label">{label}</span>
              <span className="ass-finding-count">{nodeTypes[key]}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AttackSurfaceScore;